var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-6" },
          [
            _c("vue-switch-with-label", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.allowChangeSubscription,
                  expression: "allowChangeSubscription",
                },
              ],
              attrs: {
                label: "Subscribe to Group Calendar",
                name: "subscribe",
              },
              on: { input: _vm.toggleEventsSubscription },
              model: {
                value: _vm.subscribe,
                callback: function ($$v) {
                  _vm.subscribe = $$v
                },
                expression: "subscribe",
              },
            }),
            _vm._v(" "),
            _c("vue-switch-with-label", {
              staticClass: "margin-5-top",
              attrs: { label: "Show Archived Events", name: "archive" },
              on: { input: _vm.onArchiveStatusChanged },
              model: {
                value: _vm.archive,
                callback: function ($$v) {
                  _vm.archive = $$v
                },
                expression: "archive",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-6 text-right" },
          [
            _c("vue-search-input", {
              on: { search: _vm.onSearch, cancel: _vm.onSearchCancel },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.holidays.length
        ? _c(
            "div",
            { staticClass: "margin-15-top" },
            _vm._l(_vm.holidays, function (holiday) {
              return _c("group-events-holiday", {
                key: holiday.id,
                attrs: { holiday: holiday, editable: _vm.isAdmin },
                on: {
                  onDelete: function ($event) {
                    return _vm.onHolidayDelete(holiday)
                  },
                  onEdit: function ($event) {
                    return _vm.onHolidayEdit(holiday)
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin-15-top" },
        _vm._l(_vm.results, function (event) {
          return _c("group-events-page-event", {
            key: event.id,
            attrs: { event: event },
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.allLoaded && _vm.results.length === 0
        ? _c("div", { staticClass: "margin-15-top" }, [
            _c("div", { staticClass: "alert alert-info" }, [
              _vm._v(
                "There not any Events matching your criteria in this Group yet"
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("create-event-popup", { ref: "create-event-popup" })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("group-events-page-add-holiday-popup", {
            ref: "group-events-page-add-holiday-popup",
            attrs: { "group-id": _vm.group.id },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("group-events-page-holiday-delete-popup", {
            ref: "group-events-page-holiday-delete-popup",
            attrs: { "group-id": _vm.group.id },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.loadMore,
            expression: "loadMore",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }